interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}

interface TelegramWebApp {
  ready: () => void;
  expand: () => void;
  disableVerticalSwipes?: () => void;
  initDataUnsafe?: { user?: TelegramUser };
  initData?: string;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function initTelegramSdk(): void {
  const tg = window.Telegram?.WebApp;
  if (!tg) {
    console.warn('[telegram] WebApp SDK not available (running outside Telegram?)');
    return;
  }
  tg.ready();
  tg.expand();
  tg.disableVerticalSwipes?.();
}

export function getTelegramUser(): TelegramUser | undefined {
  return window.Telegram?.WebApp?.initDataUnsafe?.user;
}

export function getInitDataRaw(): string | undefined {
  return window.Telegram?.WebApp?.initData;
}
